import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkOperationsToolbar = ({ selectedCount, onBulkStatusUpdate, onClearSelection }) => {
  const [showActions, setShowActions] = useState(false);

  const handleStatusUpdate = (status) => {
    onBulkStatusUpdate(status);
    setShowActions(false);
  };

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-full">
            <Icon name="CheckSquare" size={16} color="white" strokeWidth={2} />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">
              {selectedCount} {selectedCount === 1 ? 'request' : 'requests'} selected
            </p>
            <p className="text-xs text-muted-foreground">Choose an action to apply to selected requests</p>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <div className="relative">
            <Button
              variant="default"
              size="sm"
              iconName="Settings"
              onClick={() => setShowActions(!showActions)}
            >
              Bulk Actions
            </Button>

            {showActions && (
              <div className="absolute right-0 mt-2 w-56 bg-card border border-border rounded-lg shadow-elevation-2 py-1 z-50">
                <button
                  onClick={() => handleStatusUpdate('in-progress')}
                  className="flex items-center space-x-3 w-full px-4 py-2 text-sm text-foreground hover:bg-accent transition-colors"
                >
                  <Icon name="Play" size={16} strokeWidth={2} />
                  <span>Mark as In Progress</span>
                </button>
                <button
                  onClick={() => handleStatusUpdate('completed')}
                  className="flex items-center space-x-3 w-full px-4 py-2 text-sm text-foreground hover:bg-accent transition-colors"
                >
                  <Icon name="CheckCircle2" size={16} strokeWidth={2} />
                  <span>Mark as Completed</span>
                </button>
                <button
                  onClick={() => handleStatusUpdate('cancelled')}
                  className="flex items-center space-x-3 w-full px-4 py-2 text-sm text-destructive hover:bg-destructive/10 transition-colors"
                >
                  <Icon name="XCircle" size={16} strokeWidth={2} />
                  <span>Mark as Cancelled</span>
                </button>
                <div className="border-t border-border my-1"></div>
                <button
                  onClick={() => handleStatusUpdate('pending')}
                  className="flex items-center space-x-3 w-full px-4 py-2 text-sm text-foreground hover:bg-accent transition-colors"
                >
                  <Icon name="RotateCcw" size={16} strokeWidth={2} />
                  <span>Reset to Pending</span>
                </button>
              </div>
            )}
          </div>

          <Button
            variant="outline"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsToolbar;